import React from 'react'
import * as UMEColors from '@bit/ume.design-kit.ui/utils/_colors'
import { Box, Text } from 'grommet'
import { useDispatch } from 'react-redux'
import styled, { css } from 'styled-components'
import { SmallLoadingIcon } from '../../organisms/RetailersPage/styles'
import { RetailersSliceReducer } from '../../redux/reducers/retailers/retailers.reducer'
import { useTypedSelector } from '../../redux/reducers/selectors'
import { LoadingButton as Button } from '../LoadingButton/LoadingButton'
import Modal from './Modal'

interface Props {
  isModalOpen?: boolean
  onClose: () => void
  oldIssuer?: string
  newIssuer?: string
}

const EditRetailerIssuerModal = ({ isModalOpen, onClose, oldIssuer, newIssuer }: Props) => {
  const dispatch = useDispatch()

  const { retailer, isEditRetailerIssuerLoading, issuers } = useTypedSelector(state => ({
    retailer: state.retailers.retailer,
    isEditRetailerIssuerLoading: state.retailers.isEditRetailerIssuerLoading,
    issuers: state.retailers.issuers,
  }))

  const handleConfirmButton = () => {
    const retailerId = retailer?.id as string
    const selectedIssuer = issuers?.find(issuer => issuer.name === newIssuer)
    
    if (selectedIssuer) {
      dispatch(
        RetailersSliceReducer.actions.editRetailerIssuer({
          issuer: selectedIssuer,
          retailerId,
        })
      )
    }
  }

  return (
    <Modal modalTtitle="Confirmar alteração de emissor?" isOpen={!!isModalOpen} onClose={onClose} width={'500px'}>
      <Box overflow="auto" pad={{ top: '20px' }} margin={{ vertical: '10px' }}>
        <Box direction="row" justify="evenly">
          <Text size="18px" color={UMEColors.black.light}>
            De: <Text weight="bold">{oldIssuer || '--'}</Text>
          </Text>
          <Text size="18px" color={UMEColors.black.light}>
            Para: <Text weight="bold">{newIssuer || '--'}</Text>
          </Text>
        </Box>
        <Box width="100%" direction="row" gap="medium" justify="center" margin={{ top: '20px' }}>
          <CancelButton onClick={onClose} label={'Cancelar'} />
          <ConfirmButton
            onClick={handleConfirmButton}
            label={isEditRetailerIssuerLoading ? <SmallLoadingIcon /> : 'Confirmar'}
          />
        </Box>
      </Box>
    </Modal>
  )
}

export default EditRetailerIssuerModal

const ConfirmButton = styled(Button)`
  border-radius: 6px;
  padding: 10px;
  width: 40%;
  background-color: ${UMEColors.green.laurel};
  border: solid 1px ${UMEColors.white.primary};
  box-shadow: 2px 4px 20px -5px rgba(0, 0, 0, 0.4) !important;

  color: ${UMEColors.white.primary};
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
  transition: 0.4s;

  &:hover {
    transition: 250ms;
    opacity: 0.8;
    cursor: pointer;
  }

  ${(props: any) =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.2;
    `}
`

const CancelButton = styled(Button)`
  border-radius: 6px;
  padding: 10px;
  width: 40%;
  background-color: ${UMEColors.white.primary};
  border: solid 1px ${UMEColors.green.laurel};
  box-shadow: 2px 4px 20px -5px rgba(0, 0, 0, 0.4) !important;

  color: ${UMEColors.green.laurel};
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
  transition: 0.4s;

  &:hover {
    transition: 250ms;
    cursor: pointer;
    background-color: ${UMEColors.green.laurel};
    color: ${UMEColors.white.primary};
  }
` 